import React from 'react';
import PropTypes from 'prop-types';

import StatePicker from './StatePicker';
import RegionPicker from './RegionPicker';
import LEOData from './LEOData';

export default function LEOContactForm({
  description,
  onSelectState,
  onSelectRegion,
  state = '',
  region = '',
}) {
  if (!state) {
    // Just render the state picker
    return <StatePicker onSelect={onSelectState} />;
  }

  if (!region) {
    // State picker and region picker
    return (
      <div className='space-y-5'>
        <StatePicker value={state} onSelect={onSelectState} />
        <RegionPicker state={state} onSelect={onSelectRegion} />
      </div>
    );
  }

  // State picker, region picker, and LEO data
  return (
    <>
      <div className='space-y-5'>
        <StatePicker value={state} onSelect={onSelectState} />
        <RegionPicker state={state} value={region} onSelect={onSelectRegion} />
      </div>
      <LEOData state={state} region={region} description={description} />
    </>
  );
}

LEOContactForm.propTypes = {
  description: PropTypes.string,
  state: PropTypes.string,
  region: PropTypes.string,
  onSelectState: PropTypes.func,
  onSelectRegion: PropTypes.func,
};
